const breakpoints = {
  SMALL: 640,
  MEDIUM: 768,
  LARGE: 1024,
  XLARGE: 1280,
  XXLARGE: 1536,
}

export { breakpoints }
